export class CreateApplicationProfessionalBodiesWamsConstants {
    static STEP_TITLE = "Professional bodies";
    static PROFESSIONAL_BODY_FORM_CONTROL_NAME = "professionalBodiesForm";
    static COMPONENT_NAME = "professional-bodies";
    static MARK_IMPLEMENTING_AGENT_AS_REQUIRED_LABEL = "Are the implementing agent's details required?";
    static MARK_IMPLEMENTING_AGENT_AS_REQUIRED_FORM_CONTROL_NAME = "markImplementingAgentAsRequired";
    static COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_LABEL = "Copy applicant details to implementing agent?";
    static COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_FORM_CONTROL_NAME = "copyApplicantToImplementingAgent";
    static MARK_ENGINEER_REQUIRED_LABEL = "Are the civil engineer's details required?";
    static MARK_ENGINEER_AS_REQUIRED_FORM_CONTROL_NAME = "markEngineerAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL = "Copy applicant details to civil engineer?";
    static COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME = "copyApplicantToEngineer";
    static MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_LABEL = "Are the contractor's details required?";
    static MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_FORM_CONTROL_NAME = "markElectricalContractorAsRequired";
    static COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL = "Copy applicant details to electrical contractor?";
    static COPY_APPLICANT_DETAILS_TO_CONTRACTOR_FORM_CONTROL_NAME = "copyApplicantToContractor";
    static IMPLEMENTING_AGENT_LABEL = "Implementing agent";
    static ENGINEER_LABEL = "Engineer";
    static ELECTRICAL_CONTRACTOR_LABEL = "Electrical contractor";
    static IMPLEMENTING_AGENT_FORM_CONTROL_NAME = "implementingAgentRecipient";
    static ENGINEER_FORM_CONTROL_NAME = "engineerRecipients";
    static ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME = "responsibleContractorRecipient";
}
